import { render, staticRenderFns } from "./CustomUpload.vue?vue&type=template&id=482e6afe&scoped=true&"
import script from "./CustomUpload.vue?vue&type=script&lang=js&"
export * from "./CustomUpload.vue?vue&type=script&lang=js&"
import style0 from "./CustomUpload.vue?vue&type=style&index=0&id=482e6afe&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482e6afe",
  null
  
)

export default component.exports